// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__b3g88tck3zVM7VfTE69X","cta":"cta__n5wxWkqIy73PkLAo6AeQ","title":"title____YZifcE11wwBsK8oO_e","subtitle":"subtitle__XbOlvOEV4YMLftM2tYTR"};